<div class="dialog-header">
  <h2 mat-dialog-title>Success</h2>
  <button mat-dialog-close class="btn close-dialog-btn"></button>
</div>
<mat-dialog-content>
  <div class="alert-text"> Zone activated </div>
</mat-dialog-content>
<div mat-dialog-actions class="action-btns">
  <button mat-dialog-close class="btn" (click)="assignOutput()">Assign Output</button>
  <button mat-dialog-close class="btn" (click)="manage()">Manage</button>
</div>
